import React, { useContext, useEffect } from 'react';
import { PageContainer } from '../styles';
import { ContainerHeaderSindico, BodyHomeSindico } from './styled';
import NavbarSindico from '../NavbarSindico';
import DianaHomeSindicoImgSrc from '../../../assets/diana/grupo-direcional/diana-home-sindico.png';
import HeaderSection from '../../../Components/HeaderSection';
import { ContextSindico } from '../../../services/sindico';
import { useHistory } from 'react-router-dom';
import ContainerCardsWithAction from '../../../Components/ContainerCardsWithAction';
import srcImgSolicitacaoImovel from '../../../assets/novosicones/Sindico/solicitacoes.svg';
import srcImgDocumentosImovel from '../../../assets/novosicones/Sindico/documentos.svg';
import loadSindico from '../loadSindico';

const HomeSindico = () => {
  const { tema, logoutSindico, handleClickDocuments } =
    useContext(ContextSindico);
  const history = useHistory();
  useEffect(() => {
    if (!loadSindico()) {
      logoutSindico();
    }
  }, []);

  const cardsInfos = [
    {
      imgSrc: srcImgSolicitacaoImovel,
      title: 'Solicitações do Imóvel',
      subtitle: 'Acesse para acompanhar e fazer solicitações',
      buttonText: 'ACESSAR',
      onClickButton: () => history.push('/sindico/solicitacoes-abertas/'),
    },
    {
      imgSrc: srcImgDocumentosImovel,
      title: 'Documentos do Imóvel',
      subtitle: 'Acesse para ver os documentos do imóvel',
      buttonText: 'ACESSAR',
      onClickButton: handleClickDocuments,
    },
  ];
  return (
    <PageContainer>
      <NavbarSindico />

      <ContainerHeaderSindico tema={tema}>
        <div className='info-container'>
          <div>
            <div className='section-title'>
              <h1 className='title-home-sindico'>Olá, eu sou a Diana,</h1>
              <p className='subtitle-home-sindico'>
                assistente virtual do Grupo Direcional, <b>muito prazer!</b>
              </p>
            </div>
            <p>
              Aqui você pode fazer solicitações e acessar os documentos do seu
              imóvel.
            </p>
          </div>
          <img
            src={DianaHomeSindicoImgSrc}
            className='diana-img-home-sindico'
          />
        </div>
      </ContainerHeaderSindico>

      <BodyHomeSindico>
        <HeaderSection
          tema={tema}
          notShowButton
          title={'O que você deseja fazer?'}
          subtitle={
            'Você pode fazer e acompanhar as solicitações do seu imóvel e acessar os documentos do mesmo:'
          }
          marginBottom={0}
        />

        <ContainerCardsWithAction items={cardsInfos} theme={tema} />
      </BodyHomeSindico>
    </PageContainer>
  );
};

export default HomeSindico;
